var map = {
	"./bootstrap.svg": 698,
	"./css3.svg": 980,
	"./figma.svg": 748,
	"./git.svg": 80,
	"./github.svg": 21,
	"./html5.svg": 368,
	"./javascript.svg": 169,
	"./mongodb.svg": 966,
	"./mysql.svg": 570,
	"./nodejs.svg": 593,
	"./python.svg": 694,
	"./react.svg": 341,
	"./tailwindcss.svg": 597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;